import { render, staticRenderFns } from "./TipTapHtmlEditorField.vue?vue&type=template&id=4627ad11&"
import script from "./TipTapHtmlEditorField.vue?vue&type=script&lang=js&"
export * from "./TipTapHtmlEditorField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4627ad11')) {
      api.createRecord('4627ad11', component.options)
    } else {
      api.reload('4627ad11', component.options)
    }
    module.hot.accept("./TipTapHtmlEditorField.vue?vue&type=template&id=4627ad11&", function () {
      api.rerender('4627ad11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/form/components/TipTapHtmlEditorField.vue"
export default component.exports